import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        searchBtnText:"查询",
        insertBtnText:"创建",
        copeBtnText:"复制",
        modifyBtnText:"修改",
        deleteBtnText:"删除",
        enableBtnText:"启用",
        disableBtnText:"禁用",
        examineBtnText:"审核",
        lookBtnText:"查看",
        confirmButtonText:"保存",
        cancelButtonText:"取消",
        nextBtnText:"下一步"
    },
    mutations: {},
    actions: {},
    modules: {
        user
    },
    getters
})